import { makeStyles } from '@mui/styles';
const useStyles = makeStyles((theme) => ({
  summary: {
    flexDirection: 'row-reverse',
    pointerEvents: 'auto',
  },
  expandIcon: { pointerEvents: 'auto' },
  title: {
    verticalAlign: 'middle',
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    lineHeight: '28px',
  },
  moreHoriz: { alignItems: 'end', pointerEvents: 'auto' },
  details: {
    borderTop: `1px solid ${theme.palette.grey[900]}`,
  },
  collectionAccordionSummary: {
    backgroundColor: `${theme?.palette?.grey[900_2]}`,
  },
  stickySummary: {
    position: 'sticky',
    top: 64,
    zIndex: 5,
    boxShadow: '0 2px 8px rgba(15, 23, 42, 0.08)',
    borderBottom: `1px solid ${theme.palette.grey[900]}`,
    [theme.breakpoints.down('sm')]: {
      top: 56,
    },
  },
  noGutterAccordion: {
    '& .MuiPaper-root.MuiAccordion-root.Mui-expanded': {
      margin: 0,
      borderLeft: `solid 4px ${theme?.palette?.primary?.main}`,
    },
    '& .MuiAccordionDetails-root': {
      padding: 0,
      marginRight: 0,
    },
  },
}));

export default useStyles;
